package com.anjuros.website.templates.template2.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.styles.HeaderHeight
import com.anjuros.website.templates.template2.components.Template2Header
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2HeroColumnStyle
import com.anjuros.website.templates.template2.styles.Template2HeroTitleStyle
import com.anjuros.website.templates.template2.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flex
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2MainSection(
    modifier: Modifier = HeaderHeight.toModifier(),
    onMenuClosed:()->Unit={}){
    Box(
        modifier = modifier
            .id("home")
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template2Header() { onMenuClosed() }
            Template2HeroSection()
        }
    }
}

@Composable
fun Template2HeroSection() {

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Template2Theme.Background.rgb)
    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth()

                .gap(40.px)
                .alignItems(AlignItems.Center)
        ) {

            //====================================================
            // LEFT
            //====================================================

            Column(
                modifier = Template2HeroColumnStyle.toModifier()
            ) {

                P(
                    attrs = Modifier
                        .color(Theme.Secondary.rgb)
                        .fontSize(14.px)
                        .fontWeight(FontWeight.SemiBold)
                        .letterSpacing(1.px)
                        .margin(bottom = 16.px)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE2_HERO_BADGE))
                }

                P(
                    attrs = Template2HeroTitleStyle.toModifier()
                        .color(Template2Theme.Accent.getColor())
                        .fontWeight(FontWeight.Bold)
                        .lineHeight(1.05)
                        .margin(bottom = 0.px)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE2_HERO_TITLE))
                }

                P(
                    attrs = Template2HeroTitleStyle.toModifier()
                        .color(Template2Theme.Secondary.rgb)
                        .fontWeight(FontWeight.Bold)
                        .lineHeight(1.05)
                        .margin(bottom = 24.px)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE2_HERO_TITLE2))
                }

                P(
                    attrs = Modifier
                        .fontSize(20.px)
                        .lineHeight(1.6)
                        .color(rgb(80, 80, 80))
                        .margin(bottom = 32.px)
                        .maxWidth(620.px)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE2_HERO_DESCRIPTION))
                }

                Row(
                    modifier = Modifier
                        .gap(16.px)
                        .alignItems(AlignItems.Center)
                        .margin(bottom = 36.px)
                ) {

                    Link(
                        path = Template2Section.Contact.path,
                        modifier = Modifier.textDecorationLine(TextDecorationLine.None)
                    ) {
                        Button(
                            attrs = Modifier
                                .backgroundColor(Theme.Secondary.rgb)
                                .color(Colors.White)
                                .borderRadius(14.px)
                                .padding(
                                    left = 28.px,
                                    right = 28.px,
                                    top = 16.px,
                                    bottom = 16.px
                                )
                                .boxShadow(
                                    2.px, 2.px, 3.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                                )
                                .border(0.px)
                                .fontWeight(FontWeight.SemiBold)
                                .cursor(Cursor.Pointer)
                                .toAttrs()
                        ) {
                            Text(LocalText(ResKey.TEMPLATE2_HERO_PRIMARY_BUTTON))
                        }
                    }

                }

                Row(
                    modifier = Modifier
                        .gap(28.px)
                        .flexWrap(FlexWrap.Wrap)
                ) {

                    Template2HeroFeature.entries.forEach { feature ->

                        Row(
                            modifier = Modifier
                                .gap(12.px)
                                .alignItems(AlignItems.Start)
                        ) {

                            AnjurosIcon(
                                src = feature.icon,
                                alt = "feature",
                                modifier = Modifier
                                    .size(28.px)
                                    .margin(top = 2.px)
                            )

                            Column {

                                P(
                                    attrs = Modifier
                                        .fontWeight(FontWeight.Bold)
                                        .margin(bottom = 2.px)
                                        .toAttrs()
                                ) {
                                    Text(LocalText(feature.title))
                                }

                                P(
                                    attrs = Modifier
                                        .fontSize(14.px)
                                        .color(rgb(110, 110, 110))
                                        .margin(0.px)
                                        .toAttrs()
                                ) {
                                    Text(LocalText(feature.subtitle))
                                }
                            }
                        }
                    }
                }
            }

            //====================================================
            // RIGHT
            //====================================================

            Box(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.LG)
                    .flex(1)
                    .position(Position.Relative)
                    .minHeight(560.px)
            ) {



                // Angled image
                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(0.px)
                        .width(100.percent)
                        .height(560.px)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property(
                                "clip-path",
                                "polygon(12% 0, 100% 0, 100% 100%, 0 100%)"
                            )
                        }
                ) {

                    AnjurosImage(
                        src = "template2_hero.jpg",
                        alt = "Handyman tools",
                        modifier = Modifier
                            .fillMaxSize()
                            .objectFit(ObjectFit.Cover)
                    )
                }
            }
        }
    }
}

enum class Template2HeroFeature(
    val icon: String,
    val title: ResKey,
    val subtitle: ResKey
) {
    INSURED(
        "template2_intro1.svg",
        ResKey.TEMPLATE2_HERO_BADGE1,
        ResKey.TEMPLATE2_HERO_BADGE1_DESC
    ),
    ON_TIME(
        "template2_intro2.svg",
        ResKey.TEMPLATE2_HERO_BADGE2,
        ResKey.TEMPLATE2_HERO_BADGE2_DESC
    ),
    GUARANTEE(
        "template2_intro3.svg",
        ResKey.TEMPLATE2_HERO_BADGE3,
        ResKey.TEMPLATE2_HERO_BADGE3_DESC
    )
}